export enum ImportOption {

  Full='Full',
  Only = 'Only',
  TerminalAndAssets = 'TerminalAndAssets',
  TerminalAndPostSynchro = 'TerminalAndPostSynchro'
}
